import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserView, MobileView } from "react-device-detect";
import { DfpComponent } from "../../ads/dfp-component";
import ReadEmagazineBlack from "../ReadEmagazineBlack";
import PodcastWidget from "../PodcastWidget";
import "./newsletter.m.css";

export const Newsletter = ({ collection, config, magazineWidget, budgetTheme = true }) => {
  const networkId = get(config, ["ads-config", "network_id"], {});
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const budgetBlackTheme = get(collection, ["associated-metadata", "budget_black_theme"], false);
  const [adComponent, setAdComponent] = useState();
  const qtState = useSelector((state) => state);
  const qtConfig = get(qtState, ["qt", "config"], {});
  const isPodcastwidgetEnable = get(qtConfig, ["publisher-attributes", "podcast-widget-status"], false);
  const [isPodcastAvailable, setIsPodcastAvailable] = useState(isPodcastwidgetEnable ? null : false);
  useEffect(() => {
    setAdComponent(
      <>
        <BrowserView>
          {associatedMetadata.desktop_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.desktop_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
        </BrowserView>
        <MobileView>
          {associatedMetadata.mobile_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-mobile-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.mobile_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
        </MobileView>
      </>
    );
  }, []);

  useEffect(() => {
    setIsPodcastAvailable(isPodcastwidgetEnable ? null : false);
  }, [isPodcastwidgetEnable]);

  const newsletterFallback = (
    <div styleName="newsletter">
      {/* <ReadEmagazineBlack magazineWidget={magazineWidget} /> */}
      <div styleName={`${budgetBlackTheme ? "blacktheme" : ""} homegooglesourncebtn`}>
        <a href="https://www.google.com/preferences/source?q=fortuneindia.com" target="_blank">
          <div styleName="home-google-text">Set <span>Fortune India</span> <i styleName="checkIcon">&#10003;</i>
            <strong>As Preferred on Google</strong>
          </div>
          <button aria-label="Set Fortune India as source" styleName="proceed-home-button">Proceed</button>
        </a>
      </div>
    </div>
  );

  return (
    <div className="newsletter-container" styleName="newsletter-container">
      <div styleName="ad-wrapper-newsletter">{adComponent}</div>
      {budgetTheme && (
        <>
          {isPodcastwidgetEnable && isPodcastAvailable !== false ? (
            <PodcastWidget isTopnewWidget={true} onAvailabilityChange={setIsPodcastAvailable} />
          ) : (
            newsletterFallback
          )}
        </>
      )}
    </div>
  );
};
